import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Info: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[1.7px]', className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99984 2.29169C5.74264 2.29169 2.2915 5.74283 2.2915 10C2.2915 14.2572 5.74264 17.7084 9.99984 17.7084C14.257 17.7084 17.7082 14.2572 17.7082 10C17.7082 5.74283 14.257 2.29169 9.99984 2.29169ZM1.0415 10C1.0415 5.05247 5.05229 1.04169 9.99984 1.04169C14.9474 1.04169 18.9582 5.05247 18.9582 10C18.9582 14.9476 14.9474 18.9584 9.99984 18.9584C5.05229 18.9584 1.0415 14.9476 1.0415 10Z"
      fill="currentColor"
      strokeWidth="currentStrokeWidth"
    />
    <path
      d="M9.99984 15C10.4284 15 10.7759 14.6424 10.7759 14.2012V9.46746C10.7759 9.02628 10.4284 8.66864 9.99984 8.66864C9.57122 8.66864 9.22377 9.02628 9.22377 9.46746V14.2012C9.22377 14.6424 9.57122 15 9.99984 15Z"
      fill="currentColor"
      strokeWidth="currentStrokeWidth"
    />
    <path
      d="M9.1665 5.91716C9.1665 6.35833 9.51396 6.71598 9.94257 6.71598H10.0571C10.4857 6.71598 10.8332 6.35833 10.8332 5.91716V5.79882C10.8332 5.58641 10.751 5.38276 10.6048 5.23286C10.4586 5.08296 10.2604 4.99917 10.0541 5.00001L9.93953 5.00047C9.51211 5.00219 9.1665 5.35933 9.1665 5.79928V5.91716Z"
      fill="currentColor"
      strokeWidth="currentStrokeWidth"
    />
  </svg>
);

export default Info;
